// extracted by mini-css-extract-plugin
export default {"price":"A7-z","priceRow":"B7-z","onSale":"C7-z","msrpLabelPrice":"D7-z","msrpLabel":"E7-z","originalPrice":"F7-z","percentOff":"G7-z"};